import React from "react";
import { withContactModal } from "hocs/withContactModal";

export const ContactButton = withContactModal(({contactModalProps, className, children}) => (
  <button className={className} onClick={contactModalProps.toggle}>{children}</button>
))
